import ApiInstance from './instance'
import { ICreateResidentUserWithTempPasswordDTO, IUpdateResidentPasswordDTO } from '@zunta/configurations'

export default class ResidentPortalApi {
  instance: ApiInstance

  constructor (instance: ApiInstance) {
    this.instance = instance
  }

  createResidentUser (data: any) {
    return this.instance.doPost('/resident-portal/user', data)
  }

  sendInvitation (data: any) {
    return this.instance.doPost(`/resident-portal/generate-code/${data.residentId}/${data.facilityId}`, data)
  }

  createResidentUserWithTempPassword (data: ICreateResidentUserWithTempPasswordDTO) {
    return this.instance.doPost(`/resident-portal/user/temp-password`, data)
  }

  connectUserToResident (data: any) {
    return this.instance.doPost(`/resident-portal/add-resident`, data)
  }

  checkCode (code: string) {
    return this.instance.doPost(`/resident-portal/code`, { code })
  }

  createTempUser (code: string) {
    return this.instance.doPost(`/resident-portal/user/temp`, { code })
  }

  updateResidentUserPassword (data: IUpdateResidentPasswordDTO): Promise<'OK' & { statusCode: number, message: string}> {
    return this.instance.doPost(`/resident-portal/update-resident-password`, data)
  }

  checkResidentName (data: any) {
    return this.instance.doPost(`/resident-portal/checkResidentName`, data)
  }
}
